import { AbstractControl } from "@angular/forms";
import { Injectable } from "@angular/core";
import { CompanyMasterService } from "../../Services/company-master.service";

@Injectable()
export class CompanyMasterValidators {
  constructor(private service: CompanyMasterService) {}

  shouldBeUnique(ac: AbstractControl) {
    // ac will hold each of the form controls
    const name = ac.get("name").value;
    const id = ac.get("id").value;

    if (name != null) {
      this.service.checkForDuplicate(name, id).subscribe(
        (response) => {
          if (response.length > 0)
            ac.get("name").setErrors({ isDuplicate: true });
          else ac.get("name").setErrors(null);
        },
        (error) => {
          ac.get("name").setErrors(null);
        }
      );
    }
  }
}
